module.exports = __webpack_public_path__ + "static/media/logo_purple.28567740.png";